export default __webpack_public_path__ + "static/media/yellowEllipse.679a9773.svg";